import { useRef, useEffect } from 'react';

function Composer({ text, setText, onSend, busy }) {
  const textareaRef = useRef();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleSend = () => {
    if (text.trim() && !busy) {
      onSend();
    }
  };

  // Auto-resize textarea
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      if (!text.trim()) {
        // Force 48px when empty
        textarea.style.height = '48px';
      } else {
        // Auto-resize when content exists
        textarea.style.height = '48px'; // Reset to base height first
        const newHeight = Math.max(48, Math.min(textarea.scrollHeight, 400));
        textarea.style.height = newHeight + 'px';
      }
    }
  }, [text]);

  return (
    <div className="composer">
      <div className="composer-inner">
        <textarea
          id="message-input"
          name="message"
          ref={textareaRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your message here..."
          disabled={busy}
        />
        <button
          className={`send ${text.trim() && !busy ? 'primary' : ''}`}
          onClick={handleSend}
          disabled={!text.trim() || busy}
        >
          {busy ? <div className="loader"></div> : <span className="send-icon">⚡</span>}
        </button>
      </div>
    </div>
  );
}

export default Composer;